import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";

const getDefaultState = () => {
  return {
    isFidoActShtOpen: false, // app.vue fido 알림 action-sheet
    fidoActShtTitle: "", // app.vue fido 알림 action-sheet
    isNegativeButton: false,
    fidoActShtCancelText: "", // app.vue fido 알림 action-sheet
    fidoActShtCancelFunction: "", // app.vue fido 알림 action-sheet
    isPositiveButton: true,
    fidoActShtConfirmText: "", // app.vue fido 알림 action-sheet
    fidoActShtConfirmFunction: "", // app.vue fido 알림 action-sheet
    fidoActShtContents1: "", // app.vue fido 알림 action-sheet
    fidoActShtContents2: "", // app.vue fido 알림 action-sheet
    fidoActShtContents3: "", // app.vue fido 알림 action-sheet
    fidoPop: {
      pincodeChg: {
        // 메뉴팝업 - fido 팝업 - 간편인증 변경/해제
        isOpen: false,
      },
      pincodeConfirm: {
        // 메뉴팝업 - fido 팝업 - 간편인증 해제 확인
        isOpen: false,
      },
      fingerprintConfirm: {
        // 메뉴팝업 - fido 팝업 - 지문(faceID) 해제 확인
        isOpen: false,
      },
    },
    /**
     * fido 해지
     */
    fidoDiscard: {
      /**
       * fido해지 요청
       */
      uafRequest: {
        in: {
          device: "", // 디바이스 ID
          smphMdelName: "", // 디바이스 모델명
          bioType: "", // 인식 TYPE ( FINGERPRINT : fingerprint인식, PINCODE : PIN, PATTERN : 패턴 )
        },
        out: {
          success: {
            bioType: "", // 인식 TYPE ( FINGERPRINT : fingerprint인식, PINCODE : PIN, PATTERN : 패턴 )
            userName: "", // FIDO USERID
            systemId: "", // 시스템 정보
            fidoReqMessage: "", // 해지 요청 FIDO Protocol
          },
          fail: {},
        },
      },
      /**
       * fido해지 app 함수 호출
       */
      appReq: {
        in: {
          // uafRequest.out.success 사용.
        },
        out: {
          result: "", // 결과코드(SUCCESS/ERROR)
          uafResponse: "", // FIDO APP 응답
          errorcode: "", // ERROR코드
        },
      },
      /**
       * fido해지 응답
       */
      uafResponse: {
        in: {
          uafResponse: "", // FIDO APP 응답
          smphMchtlUniqNo: "", // 스마트폰 기기고유번호
          smphMchtlDstcd: "", // 스마트폰기기 구분코드
          pgmVsnno: "", // 프로그램버전번호
          smphMdelName: "", // 스마트폰모델명
          bioType: "", // 인식 TYPE ( FINGERPRINT : fingerprint인식, PINCODE : PIN, PATTERN : 패턴 )
        },
        out: {
          success: {
            statusCode: "", // 상태코드
            Description: "", // 에러코드 설명
            USERNAME: "", // FIDO USERID
          },
          fail: {},
        },
      },
    },
  };
};

const manageFido = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    /**
     * fido관련 메뉴팝업 open/close 를 변경함.
     * @param {*} state
     * @param {*} payload
     */
    mut001_manageFido: function(state, payload) {
      if (payload === "pincodeChg") {
        state.fidoPop.pincodeChg.isOpen = true;
        state.fidoPop.pincodeConfirm.isOpen = false;
        state.fidoPop.fingerprintConfirm.isOpen = false;
      } else if (payload === "pincodeConfirm") {
        state.fidoPop.pincodeChg.isOpen = false;
        state.fidoPop.pincodeConfirm.isOpen = true;
        state.fidoPop.fingerprintConfirm.isOpen = false;
      } else if (payload === "fingerprintConfirm") {
        state.fidoPop.pincodeChg.isOpen = false;
        state.fidoPop.pincodeConfirm.isOpen = false;
        state.fidoPop.fingerprintConfirm.isOpen = true;
      } else if (payload === "allclose") {
        state.fidoPop.pincodeChg.isOpen = false;
        state.fidoPop.pincodeConfirm.isOpen = false;
        state.fidoPop.fingerprintConfirm.isOpen = false;
      }
    },
    /**
     * fido해지 appReq 응답데이터를 업데이트 함.
     * @param {*} state
     * @param {*} payload
     */
    mut002_manageFido: function(state, payload) {
      this._vm.$set(state.fidoDiscard.appReq.out, payload.key, payload.value);
    },
  },
  actions: {
    /**
     * FIDO 해지요청
     * @param {*} context
     * @param {*} payload
     * fido 해지 시작
     * act001_manageFido -> act002_manageFido -> this._vm.$bridge.fidoDiscard
     * -> fidoDiscard_callback -> act003_manageFido
     */
    act001_manageFido: function(context, payload) {
      Object.assign(context.state.fidoDiscard, getDefaultState().fidoReg);
      context.state.fidoDiscard.uafRequest.in = payload;

      return new Promise(resolve => {
        this._vm.$post(
          "/auth/fido/fidoDiscard/uafRegRequest",
          context.state.fidoDiscard.uafRequest.in,
          response => {
            this._vm.$set(context.state.fidoDiscard.uafRequest.out, "success", response);
            context.dispatch("act002_manageFido", "fidoDiscard");
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.fidoDiscard.uafRequest.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * native bridge call
     */
    act002_manageFido: function(context, payload) {
      switch (payload) {
        case "fidoDiscard":
          this._vm.$bridge.fidoDiscard(context.state.fidoDiscard.uafRequest.out.success);
          break;
        case "setSimpleLogin":
          // FINGERPRINT 해지시 -> PINCODE 로 등록. 만약 PINCODE 등록여건이 안되면 IDPW ?
          this._vm.$bridge.setSimpleLogin({
            userName: context.state.fidoDiscard.uafRequest.out.success.userName,
            bioType: "PINCODE",
            siteCode: this.state.siteCode,
          });
          break;
        case "registeredBiometry":
          this._vm.$bridge.registeredBiometry();
          break;
      }
    },
    /**
     * fido 등록해지 callback 실행
     */
    act003_manageFido: function(context) {
      // PINCODE 해지인 경우, FINGERPRINT도 해지..
      if (context.state.fidoDiscard.uafRequest.in.bioType === "PINCODE") {
        context.dispatch("act001_manageFido", {
          device: this.state.native.smphMchtlUniqNo,
          smphMdelName: this.state.native.smphMdelName,
          bioType: "FINGERPRINT",
        });
      }

      // PINCDOE 해지시 -> 마지막은 FINGERPRINT
      // FINGERPRINT 해지시 -> 마지막은 FINGERPRINT
      if (context.state.fidoDiscard.uafRequest.in.bioType === "FINGERPRINT") {
        context.dispatch("act002_manageFido", "setSimpleLogin");
        this.state.simpleLogin.siteCodeForSimpleLogin = ""; // main화면 mounted, updated 실행
        context.commit("mut001_manageFido", "allclose");
        this.state.menuOpen = false;
      }
    },
    /**
     * fido Fingerprint 발급 시작..
     */
    act004_manageFido: async function() {
      // 간편인증번호가 이미 등록되어 있는지 확인.[S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      const result = await this._actions["auth/createFido/act014_createFido"][0]("PINCODE");

      if (result.isPincode !== "1") {
        this.state.auth.createFido.isFidoPopOpen = true;
        this.state.auth.createFido.fidoPopMessage = "MOTP-CERTN-21"; //MOTP-CERTN-21 : 먼저 간편인증번호 설정이 필요합니다.
        this.state.auth.createFido.fidoPopConfirm = () => {
          this.state.auth.createFido.isFidoPopOpen = false;
          router.push({ name: "createFidoPincodeStep1" });
        };
        return;
      }
      // 간편인증번호가 이미 등록되어 있는지 확인.[E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

      // 간편인증번호 인증 - 인증 후 발급처리
      const param = {
        device: this.state.native.smphMchtlUniqNo,
        smphMdelName: this.state.native.smphMdelName,
        bioType: "PINCODE",
        bizDscd: "createFingerprint",
      };
      // act015_createFido -> brige -> act017_createFido
      this._actions["auth/createFido/act015_createFido"][0](param);
    },
    /**
     * 기기에 생체정보 등록여부 확인.
     */
    act005_manageFido: function(context) {
      // bridge -> act006_manageFido
      context.dispatch("act002_manageFido", "registeredBiometry");
    },
    /**
     * 기기에 생체정보 등록여부 확인 callback.
     */
    act006_manageFido: function(context) {
      if (this.state.auth.createFido.isRegistBiometry === "0") {
        this.state.auth.manageFido.isFidoActShtOpen = true;
        this.state.auth.manageFido.fidoActShtTitle = "MLGI-06-02-04-01"; // 인증 사용 안내
        this.state.auth.manageFido.isNegativeButton = false;
        this.state.auth.manageFido.isPositiveButton = true;
        this.state.auth.manageFido.fidoActShtConfirmText = "MLGI-06-02-03-03"; // 확인
        this.state.auth.manageFido.fidoActShtContents1 = "FIDO-0003"; // 등록된 생체 인증이 없습니다.
        this.state.auth.manageFido.fidoActShtContents2 = "MLGI-06-02-04-02"; // 지문 또는 Face ID를 사용하기 위해서는 휴대폰에 기능으로 들어있는 인증을 먼저 설정하셔야 합니다
        this.state.auth.manageFido.fidoActShtConfirmFunction = () => {
          this.state.auth.manageFido.isFidoActShtOpen = false;
        };
      } else {
        // fido Fingerprint 발급 시작..  호출!!
        context.dispatch("act004_manageFido");
      }
    },
  },
};

export default manageFido;
